<template>
	<div>
		<div class="container-fluid">
			<form class="form-horizontal" action="." method="post">
				<div class="tabs text-center">
					<button
						@click.prevent="tab = 'main'"
						:class="tab === 'main' ? 'active' : ''"
						class="btn"
					>
						{{ 'General' | translate }}
					</button>
					<button
						@click.prevent="tab = 'documents'"
						:class="tab === 'documents' ? 'active' : ''"
						class="btn"
					>
						{{ 'Documents' | translate }}
					</button>
					<button
						v-if="myRole === 'super franchise'"
						@click.prevent="tab = 'comment'"
						:class="tab === 'comment' ? 'active' : ''"
						class="btn"
					>
						{{ 'Comment' | translate }}
					</button>
				</div>
				<div class="row">
					<div
						v-show="tab === 'main'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset>
							<legend>{{ 'General information' | translate }}</legend>
							<div class="form-group">
								<label>Email</label>
								<div>
									<input
										:class="emailError ? 'error' : ''"
										v-model="parent.email"
										type="email"
										class="form-control"
									/>
								</div>
								<div class="text-right text-danger" v-if="emailError">
									{{ emailError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Phone number' | translate }}</label>
								<div>
									<input
										:class="numberError ? 'error' : ''"
										v-model="parent.phone_number"
										type="text"
										class="form-control"
									/>
								</div>
								<div class="text-right text-danger" v-if="numberError">
									{{ numberError }}
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'First name' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="parent.first_name"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Surname' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="parent.middle_name"
										class="form-control"
									/>
								</div>
							</div>
							<div class="form-group">
								<label>{{ 'Last name' | translate }}</label>
								<div>
									<input
										type="text"
										v-model="parent.last_name"
										class="form-control"
									/>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-show="tab === 'documents'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<fieldset class="scans">
							<legend>{{ 'Documents' | translate }}</legend>
							<div class="form-group">
								<input
									type="file"
									ref="file"
									@change="uploadImage"
									class="btn btn-secondary form-control-file"
								/>
							</div>
							<div v-for="(file, i) in fileList" :key="i" class="item row">
								<div class="col-sm-12 col-md-6">{{ file.name }}</div>
								<div class="actions col-md-6 col-sm-12">
									<a
										:href="'https://api.indigo.teeko.io' + file.file"
										download
										class="btn btn-success"
										>{{ 'Download' | translate }}</a
									>
									<button
										@click.prevent="deleteFile(file.id)"
										class="btn btn-danger"
									>
										{{ 'Delete' | translate }}
									</button>
								</div>
							</div>
						</fieldset>
					</div>
					<div
						v-if="myRole === 'super franchise'"
						v-show="tab === 'comment'"
						class="tab-content col-lg-6 col-md-8 mr-auto ml-auto col-sm-12"
					>
						<b>{{ 'Comment' | translate }}</b>
						<textarea class="form-control" v-model="parent.comments"></textarea>
					</div>
					<div class="col-12 text-center">
						<input
							type="submit"
							:value="'Save' | translate"
							@click.prevent="changeProfile"
							class="btn btn-primary submit"
						/>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Parent',
	data() {
		return {
			tab: 'main',
			myRole: this.$store.state.myProfile.role,
			emailError: '',
			idForImage: '',
			fileList: [],
			numberError: '',
		}
	},
	computed: {
		parent() {
			return this.$store.state.profile
		},
	},
	methods: {
		deleteFile(fileId) {
			this.axios({
				method: 'delete',
				url: `billing/files/${fileId}`,
			}).then(response => {
				this.reloadDocuments()
			})
		},
		uploadImage(e) {
			let files = e.target.files
			let data = new FormData()
			for (var i = 0; i < files.length; i++) {
				let file = files.item(i)
				data.append(file.name, file, file.name)
			}
			const config = {
				headers: {
					'content-type': 'multipart/form-data',
				},
			}
			return this.axios
				.post(`billing/files?uploaded_by=${this.idForImage}`, data, config)
				.then(response => {
					this.reloadDocuments()
				})
		},
		reloadDocuments() {
			this.axios({
				method: 'get',
				url: `billing/files?user=${this.idForImage}`,
			}).then(response => {
				this.fileList = response.data
			})
		},
		changeProfile() {
			let error = false
			this.emailError = ''
			this.numberError = ''

			if (this.parent.email === '') {
				this.emailError = this.$t('Field required')
				error = true
			}

			if (this.parent.phone_number === '') {
				this.numberError = this.$t('Field required')
				error = true
			}

			if (error) {
				return false
			}

			let method = this.$route.params.id !== 'me' ? 'patch' : 'post'
			this.axios({
				method: method,
				url: `users/user/${this.$route.params.id}`,
				data: {
					email: this.parent.email,
					phone_number: this.parent.phone_number,
					first_name: this.parent.first_name,
					middle_name: this.parent.middle_name,
					last_name: this.parent.last_name,
					comments: this.parent.comments,
				},
			})
				.then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
				})
				.catch(error => {
					if (error.response.data.phone_number) {
						this.numberError = this.$t(error.response.data.phone_number[0])
					}

					if (error.response.data.email) {
						this.emailError = this.$t(error.response.data.email[0])
					}

					if (error.response.data.detail) {
						this.emailError = this.$t(error.response.data.detail[0])
					}
				})
		},
		updateProfile() {
			if (this.$route.params.id === 'me') {
				this.idForImage = this.$store.state.myProfile.role
			} else {
				this.idForImage = this.$route.params.id
			}
			this.reloadDocuments()
		},
	},
	created() {
		this.updateProfile()
	},
	watch: {
		$route(from, to) {
			this.updateProfile()
		},
	},
}
</script>

<style scoped>
.nav-pills li {
	margin: 10px;
}

.submit {
	margin-top: 20px;
	margin-bottom: 20px;
}

.nav-pills {
	-webkit-flex-wrap: wrap;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
}

nav {
	margin: 50px auto;
}

.tabs .btn {
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
}

.tabs .active {
	background-color: #fff;
}

.tab-content {
	border: 1px solid buttonface;
	border-radius: 10px;
	background: #fff;
	padding-top: 30px;
	padding-bottom: 30px;
}

span {
	margin-bottom: 20px;
	display: block;
}
</style>
